import { useRef } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './AboutSection.css';

function AboutSection() {
  const { sectionRef, isVisible } = useIntersectionObserver();

  return (
    <section id="about" className="about" ref={sectionRef}>
      <div className="about-wrapper">
        <div className="trust-pill">
          ☆ Trusted by 1,00,000+ customers
        </div>
        <div className="about-container">
          <div className={`about-card ${isVisible ? 'animate' : ''}`}>
            <h1 className="about-title">About</h1>
            <div className="about-description">
              <p className="about-text-animate">
                At RSKPay, we believe payments should be simple, quick, and accessible for everyone. Whether it's a mobile recharge, electricity bill, DTH payment, or even managing loans — we bring it all under one secure platform.
              </p>
              <p className="about-text-animate delay-1">
                No more juggling multiple apps. With RSKPay, your money, recharges, and bills are just one tap away.
              </p>
            </div>
          </div>
          <div className={`about-phone ${isVisible ? 'animate' : ''}`}>
            <svg className="about-phone-svg" viewBox="0 0 320 640" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="aboutPhoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 0.3 }} />
                  <stop offset="50%" style={{ stopColor: '#ffffff', stopOpacity: 0.15 }} />
                  <stop offset="100%" style={{ stopColor: '#ffffff', stopOpacity: 0.3 }} />
                </linearGradient>
                <filter id="aboutGlow">
                  <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                  <feFlood floodColor="#ffffff" floodOpacity="0.6" result="whiteFlood"/>
                  <feComposite in="whiteFlood" in2="coloredBlur" operator="in" result="whiteGlow"/>
                  <feGaussianBlur in="whiteGlow" stdDeviation="4" result="finalGlow"/>
                  <feMerge>
                    <feMergeNode in="finalGlow"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              </defs>
              
              {/* Phone outer frame with white outline */}
              <rect x="10" y="10" width="300" height="620" rx="40" fill="none" stroke="url(#aboutPhoneGradient)" strokeWidth="3" filter="url(#aboutGlow)"/>
              <rect x="15" y="15" width="290" height="610" rx="37" fill="rgba(255, 255, 255, 0.05)" stroke="rgba(255, 255, 255, 0.2)" strokeWidth="1"/>
              
              {/* Phone screen - black */}
              <rect x="25" y="80" width="270" height="520" rx="25" fill="#000000" stroke="rgba(255, 255, 255, 0.3)" strokeWidth="1"/>
              
              {/* Notch */}
              <rect x="120" y="25" width="80" height="25" rx="12" fill="rgba(255, 255, 255, 0.1)" stroke="rgba(255, 255, 255, 0.3)" strokeWidth="1"/>
              <circle cx="140" cy="37" r="3" fill="rgba(255, 255, 255, 0.4)"/>
              <rect x="150" y="35" width="30" height="4" rx="2" fill="rgba(255, 255, 255, 0.3)"/>
              
              {/* Side buttons with white shading */}
              <rect x="5" y="120" width="6" height="50" rx="3" fill="rgba(255, 255, 255, 0.3)" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1"/>
              <rect x="5" y="200" width="6" height="40" rx="3" fill="rgba(255, 255, 255, 0.3)" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1"/>
              <rect x="309" y="150" width="6" height="80" rx="3" fill="rgba(255, 255, 255, 0.3)" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="1"/>
              
              {/* Bottom indicator */}
              <rect x="135" y="615" width="50" height="4" rx="2" fill="rgba(255, 255, 255, 0.4)"/>
              
              {/* Logo container on screen - centered and floating */}
              <foreignObject x="85" y="240" width="150" height="150">
                <div xmlns="http://www.w3.org/1999/xhtml" style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img 
                    src={process.env.PUBLIC_URL + '/rskpay.png'} 
                    alt="RSKPay Logo" 
                    className="floating-logo-svg"
                    style={{
                      width: '120px',
                      height: '120px',
                      objectFit: 'contain',
                      animation: 'floatLogo 3s ease-in-out infinite'
                    }}
                  />
                </div>
              </foreignObject>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;